import { useNavigate } from 'react-router-dom'
import { AlertStatusModal } from '@/shared/components/confirmation'
import { INSTRUMENT_INFO_CAPACITY_MODAL } from '../lib/instrument-info-messages'

interface InstrumentCapacityDialogProps {
  readonly open: boolean
}

/** TC-BE-03 — survey at response target; Figma alert modal (4418:10043). */
export function InstrumentCapacityDialog({ open }: InstrumentCapacityDialogProps) {
  const navigate = useNavigate()
  const goHome = () => navigate('/', { replace: true })

  return (
    <AlertStatusModal
      open={open}
      headline="Survey unavailable"
      bodyLines={[INSTRUMENT_INFO_CAPACITY_MODAL]}
      primaryLabel="OK"
      onPrimary={goHome}
      onClose={goHome}
      dialogTestId="instrument-capacity-dialog"
      primaryTestId="instrument-capacity-dialog-ok"
    />
  )
}
